import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiChevronRight, FiFileText } from 'react-icons/fi';
import { useTheme } from '../context/ThemeContext';

const Card = ({ title, link, subtitle }) => {
  useTheme();

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      whileHover={{ y: -2 }}
      transition={{ duration: 0.2 }}
    >
      <Link
        to={link}
        className="group block relative overflow-hidden rounded-2xl transition-all duration-300 px-6 py-5"
        style={{
          textDecoration: 'none',
          backgroundColor: 'var(--bg-card)',
          border: '1px solid var(--border)',
          backdropFilter: 'blur(10px)'
        }}
      >
        {/* Hover Highlight Gradient */}
        <div className="absolute inset-0 bg-gradient-to-r from-green-400/0 via-green-400/5 to-green-400/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

        <div className="relative z-10 flex items-center justify-between gap-6">
          <div className="flex items-center gap-5">
            {/* Icon Box */}
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-green-400/20 to-green-600/20 border border-white/5 flex items-center justify-center text-green-400 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-green-500/5">
              <FiFileText size={22} className="group-hover:rotate-12 transition-transform" />
            </div>

            {/* Content */}
            <div>
              <h3 className="text-base md:text-lg font-bold group-hover:text-green-400 transition-colors leading-tight" style={{ color: 'var(--text-main)' }}>
                {title}
              </h3>
              <p className="text-xs mt-1 uppercase tracking-wider font-medium" style={{ color: 'var(--text-muted)' }}>
                {subtitle || "Study Material • Notes • PYQs"}
              </p>
            </div>
          </div>

          {/* Action Arrow */}
          <div className="flex items-center gap-3">
            <span className="hidden md:block text-xs font-bold text-gray-600 group-hover:text-green-400/70 transition-colors uppercase tracking-widest opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300">
              Access Now
            </span>
            <div className="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300" style={{ backgroundColor: 'var(--bg-surface)', border: '1px solid var(--border)', color: 'var(--text-muted)' }}>
              <FiChevronRight size={18} />
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default Card;
